import React, { useState, useEffect } from 'react';
import { TouchableOpacity, StyleSheet } from 'react-native';
import { Text, View } from '../Themed';

export type TextButtonPropsType = {
  text: string;
  disabled?: boolean;
  style?: any;
  textStyle?: any;
  containerStyle?: any;
  onPress: () => void;
};

function TextButton(props: TextButtonPropsType) {
  const [disabled, setDisabled] = useState(props.disabled);

  useEffect(() => {
    setDisabled(props.disabled);
  }, [props.disabled]);

  const containerStyle = [TextButtonStyleDefault.textButtonContainer, props.containerStyle, props.style];

  return (
    <TouchableOpacity
      style={[containerStyle, disabled ? { backgroundColor: 'gray' } : {}]}
      disabled={disabled}
      onPress={() => (typeof props.onPress === 'function' ? props.onPress() : () => {})}
    >
      <Text style={[TextButtonStyleDefault.textButtonText, props.textStyle]}>{props.text || '<Text>'}</Text>
    </TouchableOpacity>
  );
}

export const TextButtonStyleDefault = StyleSheet.create({
  textButtonContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    borderRadius: 5,
    paddingLeft: 16,
    paddingRight: 16,
  },
  textButtonText: {
    fontSize: 17,
    alignSelf: 'center',
    textAlign: 'center',
    color: 'white',
  },
});

// TextButton.propTypes = TextButtonPropTypes;
TextButton.defaultProps = {
  onPress: () => {},
};

export default TextButton;
